import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { func, string, shape, any, arrayOf, bool } from 'prop-types';
import Radium from 'radium';
import numeral from 'numeral';
import { WithLoading } from '@widergy/energy-ui';

import { billPropTypes, billProgressPropTypes } from 'types/billTypes';
import { accountPropTypes } from 'redux/accountHandlers';
import { actionCreators as paymentActions } from 'redux/paymentHandlers';
import { accountUnpaidType } from 'types/paymentTypes';
import UTErrorScreen from 'app/components/UTErrorScreen';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';

import Payment from './components/Payment';
import LastBill from './components/LastBill';
import ConsumptionComparison from './components/ConsumptionComparison';
import ConsumptionHistory from './components/ConsumptionHistory';
import styles from './styles';

const paymentDetailsMapper = (clientNumber, bills) =>
  bills.map(bill => ({
    client_number: clientNumber,
    external_id: bill.external_id,
    amount: bill.balance || bill.amount,
    barcode: bill.barcode
  }));

class BillsDetails extends PureComponent {
  handleAccountPayment = async () => {
    await this.props.dispatch(paymentActions.getAccountUnpaid(this.props.currentAccount));
    if (this.props.accountUnpaid && this.props.accountUnpaid.length > 0) {
      const { balance, debts, client_number: clientNumber } = this.props.accountUnpaid[0];
      const paymentDetails = paymentDetailsMapper(clientNumber, debts);
      this.props.dispatch(paymentActions.paymentFlowInit(balance, paymentDetails));
    }
  };

  render() {
    const {
      bill,
      progress,
      onDownloadBill,
      onDownloadPaymentDocument,
      currentAccount,
      consumptionHistory
    } = this.props;

    const balance = currentAccount ? currentAccount.balance : 0;
    return (
      <div style={styles.container}>
        <Payment
          currentBalance={numeral(balance).format('$0,0.[00]')}
          onDownloadPaymentDocument={onDownloadPaymentDocument}
          onAccountPayment={this.handleAccountPayment}
          accountUnpaidLoading={this.props.accountUnpaidLoading}
        />
        {bill ? (
          [
            <LastBill key="lastBill" bill={bill} onDownloadBill={onDownloadBill} />,
            appConfig.accountStatus.consumptionHistory ? (
              <ConsumptionHistory
                key="consumptionHistory"
                consumptionHistory={consumptionHistory}
                chartType={currentAccount && currentAccount.chart_type}
              />
            ) : (
              <ConsumptionComparison
                key="consumptionComparison"
                progress={progress}
                chartType={currentAccount && currentAccount.chart_type}
              />
            )
          ]
        ) : (
          <UTErrorScreen error mssg={message('AccountStatus:noBillsAssociatedError')} />
        )}
      </div>
    );
  }
}

BillsDetails.propTypes = {
  bill: shape({
    ...billPropTypes,
    consumption: string.isRequired,
    amount: string.isRequired,
    printedBill: string
  }),
  onDownloadBill: func.isRequired,
  onDownloadPaymentDocument: func.isRequired,
  progress: billProgressPropTypes,
  consumptionHistory: any, // eslint-disable-line react/forbid-prop-types
  currentAccount: accountPropTypes,
  accountUnpaid: arrayOf(accountUnpaidType),
  accountUnpaidLoading: bool
};

const mapStateToProps = store => ({
  accountsLoading: store.account.accountsLoading,
  accountUnpaid: store.payment.accountUnpaid,
  accountUnpaidLoading: store.payment.accountUnpaidLoading,
  paymentRequestLoading: store.payment.paymentRequestLoading
});

export default connect(mapStateToProps)(WithLoading(props => props.loading)(Radium(BillsDetails)));
